import { useCallback, useState } from "react";
import color from "../../common/color";
import { track } from "../../utils";
import GoogleFormWaitlist from "./GoogleFormWaitlist";

export default function TellUs({ onActivity }) {
  const [openGoogleFormWaitlist, setGoogleFormWaitlist] = useState(false);
  const onTellUs = useCallback(
    (event) => {
      event.preventDefault();
      onActivity();
      setGoogleFormWaitlist(true);
      track("Unsupported Leads link clicked");
    },
    [onActivity]
  );

  const onCloseGoogleFormWaitlist = useCallback(() => {
    onActivity();
    setGoogleFormWaitlist(false);
  }, [onActivity]);

  return (
    <div
      className="p-2 bg-sky-50 font-normal text-[15px]"
      style={{ backgroundColor: color.WiserLightBlue }}
    >
      <div className="text-center">
        <span>Can't find what you're looking for? </span>
        <a
          href={process.env.REACT_APP_FORM_WAITLIST_URL}
          onClick={onTellUs}
          className="cursor-pointer underline"
          target="_blank"
          rel="noreferrer"
          style={{ color: color.WiserBlue }}
        >
          Tell us what you need.
        </a>
      </div>
      <div className="text-center">We add a new product every 7 seconds</div>
      <GoogleFormWaitlist
        open={openGoogleFormWaitlist}
        onCancel={onCloseGoogleFormWaitlist}
      />
    </div>
  );
}
